import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { withRouter } from 'react-router-dom'

import { SignupStep } from './components/SignupStep'

import { getCookie } from 'srcReact/helpers/utils'
import PageContainer from 'srcReact/PageContainer/PageContainer'

import styles from './styles.module.scss'
import { useDispatch } from 'react-redux'
import { loginActions } from 'srcReact/LoginPage/actions'

const ResetPasswordPage = ({ location }) => {
  const { t } = useTranslation()
  const datas = {
    email: {
      title: t('resetPasswordPage.title'),
      rightTitle: t('resetPasswordPage.rightTitle'),
      description: t('resetPasswordPage.description'),
    },
  }

  const passwordResetKey = new URLSearchParams(location.search).get('k')
  return (
    <PageContainer
      pageTitle={t('resetPasswordPage.title')}
      pageClassName={styles.signup}
      withFooter={false}
      isPlainBanner={true}>
      <SignupStep
        title={datas.email.title}
        rightTitle={datas.email.rightTitle}
        description={datas.email.description}
        passwordResetKey={passwordResetKey}
      />
    </PageContainer>
  )
}

export default withRouter(ResetPasswordPage)
